exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-details__price .prices span {\n  font-family: freight-big-pro, Times, Times New Roman, Georgia, serif;\n  font-style: italic;\n  font-size: 1.125rem;\n  line-height: 1.313rem;\n}\n.product-details .quantity-select-action {\n  max-width: 110px;\n}\n.product-details .quantity-select-action input[type='number'] {\n  border-color: #e4e4e4;\n  padding: 0;\n  text-align: center;\n}\n.product-details .quantity-select-action button {\n  border: none;\n  height: 26px;\n  margin: 0 2px;\n  padding-top: 6px;\n  width: 26px;\n}\n", ""]);

// exports
